(function () {
  var bar = document.getElementById("pa-annbar");

  if (!bar) {
    return;
  }

  var storageKey = "paAnnDismissed";
  var closeButton = bar.querySelector(".pa-annbar__x");
  var isDismissible = bar.getAttribute("data-dismissible") === "true";
  var ticking = false;

  function wasDismissed() {
    try {
      return window.sessionStorage.getItem(storageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function saveDismissal() {
    try {
      window.sessionStorage.setItem(storageKey, "1");
    } catch (error) {
      // The bar still closes when storage is blocked; it simply returns on the next page.
    }
  }

  function updateHeaderOffset() {
    var offset = 0;

    if (!bar.hidden) {
      var barRect = bar.getBoundingClientRect();
      var adminBar = document.getElementById("wpadminbar");
      var adminBarHeight = adminBar ? adminBar.getBoundingClientRect().height : 0;

      offset = Math.max(0, Math.min(barRect.height, barRect.bottom - adminBarHeight));
    }

    document.documentElement.style.setProperty("--pa-annbar-offset", offset + "px");
    ticking = false;
  }

  function queueHeaderOffset() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderOffset);
      ticking = true;
    }
  }

  if (isDismissible && wasDismissed()) {
    bar.hidden = true;
  }

  updateHeaderOffset();
  window.addEventListener("scroll", queueHeaderOffset, { passive: true });
  window.addEventListener("resize", queueHeaderOffset);

  if (isDismissible && closeButton) {
    closeButton.addEventListener("click", function () {
      bar.hidden = true;
      saveDismissal();
      updateHeaderOffset();
    });
  }
})();
